import React from 'react'
import styled, { css } from 'styled-components'

const width = '88'
const height = '88'
const viewBox = '0 0 88 88'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="none" fillRule="evenodd" key="key-0">
      <path fill="#19C784" d="M40.762 0L88 47.238V88L0 0h40.762z" />
      <path
        fill="#FFF"
        d="M36.391 11.4c1.676 1.676 1.668 4.056.039 5.685-1.63 1.63-4.01 1.637-5.686-.039-1.68-1.68-1.664-4.052-.035-5.682 1.63-1.63 4.002-1.645 5.682.035zm-1.042 1.042c-1-1-2.45-1.004-3.508.054-1.058 1.058-1.054 2.508-.055 3.508 1.008 1.007 2.45 1.003 3.508-.054 1.058-1.058 1.062-2.501.055-3.508zm5.194 14.2l5.445-5.444-1.09-1.089-3.636 3.636.871-6.401-1.015-1.015-5.444 5.445 1.085 1.085 3.64-3.633-.875 6.398 1.019 1.019zm13.285 2.195c1.676 1.676 1.669 4.056.04 5.685-1.63 1.63-4.01 1.638-5.687-.038-1.68-1.68-1.664-4.053-.035-5.682 1.63-1.63 4.002-1.646 5.682.035zm-1.042 1.042c-1-1-2.45-1.004-3.508.054-1.058 1.058-1.054 2.509-.054 3.508 1.007 1.008 2.45 1.004 3.508-.054 1.057-1.058 1.061-2.5.054-3.508zm6.345 10.942l1-1-2.73-2.73 1.24-1.24 2.913 2.913 1-1-3.998-3.998-5.445 5.445 1.085 1.085 2.205-2.205 2.73 2.73zm5.976 5.976l1-1-2.73-2.73 1.24-1.24 2.913 2.912 1-1-3.999-3.997-5.444 5.445 1.085 1.085 2.205-2.205 2.73 2.73zm4.023 8.433l.996-.995-2.983-2.983L68.395 50l2.816 2.815.996-.995-2.816-2.816 1.206-1.206 2.951 2.952.996-.995-4.037-4.037-5.445 5.444 4.068 4.068zm9.85-1.04c1.299 1.3 1.38 2.61.338 3.652-.894.895-2.123.879-3.275-.062l-.505 3.858-1.315-1.315.58-3.753-.32-.319-2.165 2.167-1.085-1.085 5.444-5.445 2.303 2.302zm-2.217-.218l-1.334 1.334 1.198 1.198c.595.595 1.112.685 1.575.222.455-.455.338-.976-.241-1.556l-1.198-1.198z"
      />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'BannerVehicleOnOffer'
})
